import { render, staticRenderFns } from "./CourseList.vue?vue&type=template&id=7c78b534"
import script from "./CourseList.vue?vue&type=script&lang=js"
export * from "./CourseList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c78b534')) {
      api.createRecord('7c78b534', component.options)
    } else {
      api.reload('7c78b534', component.options)
    }
    module.hot.accept("./CourseList.vue?vue&type=template&id=7c78b534", function () {
      api.rerender('7c78b534', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/test/manytomany/CourseList.vue"
export default component.exports